import { DynamicAttributeFieldListFragment } from "gql/graphql";
import { FilterObject } from "../model/types";

export function filterObjectToFormFields(
  filter: FilterObject | null,
  meta: DynamicAttributeFieldListFragment,
) {
  return meta.attributes.map((attribute) => ({
    attributeCode: attribute.attributeCode,
    value: filter?.[attribute.attributeCode] ?? null,
  }));
}
